import React from "react";
import { connect } from "react-redux";

import loader from '../../assets/images/loader.gif'
import "./coldSmtpSearch.css";
import { coldSMTPSearch } from "../../actions/index";
import history from "../../history";

export class ColdSmtpSearch extends React.Component {

  constructor(props) {
    super(props);
    this.searchBox = React.createRef();
    this.searchButton = React.createRef();
    this.state = {
      showError: false,
      errorMessage: ""
    }

  }

  componentDidMount() {

    if (this.props.searchTerm && (!this.props.coldSmtp.uData || !this.props.coldSmtp.uData.length) ) {
      
      this.getInfo();
    }
  }
  handleKeyPressOnInput = (e) => {

    if (e.key === 'Enter') {
      this.getInfo()
    }
  }
 

  getInfo = () => {
    this.searchButton.current.disabled = true;
    this.searchButton.current.innerHTML = `<img src=${loader} alt='loader' width="40%" />`;

    let searchTerm = this.searchBox.current.value ? this.searchBox.current.value.trim() : this.props.searchTerm ? this.props.searchTerm.trim() : '';

    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
    const domainRegex = /^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
    history.push(`/coldSmtp/${searchTerm}`)
      
    if (emailRegex.test(searchTerm) || domainRegex.test(searchTerm)) {
        this.props.coldSMTPSearch(searchTerm)
            .then((response) => {
                this.searchButton.current.disabled = false;
                this.searchButton.current.innerHTML = "Get Info";
                if (response === 'success') {
                    if (!this.props.coldSmtp.uData && !this.props.coldSmtp.dSearchData) {
                        this.setState({ errorMessage: 'No Results Found!', showError: true });
                    } else {
                        this.setState({ errorMessage: '', showError: false });
                    }
                } else {
                    this.setState({ errorMessage: 'An error occurred while performing this operation', showError: true });
                }
            });
    } else {
        this.searchButton.current.disabled = false;
        this.searchButton.current.innerHTML = "Get Info";
        this.setState({ errorMessage: 'Enter a valid SMTP Domain or Email Address', showError: true });
    }
};


  render() {
    return (
      <div className="coldSmtpSearch">
        <div className="coldSmtpSearch-title">Enter SMTP Domain / User Email</div>
        <div className="coldSmtpSearch-box">
          <input type='text' id="campaignSearch" placeholder="example.com / user@example.com" 
          onKeyDown={this.handleKeyPressOnInput} ref={this.searchBox} 
          defaultValue={this.props.coldSmtp.search ? this.props.coldSmtp.search : this.props.searchTerm ? this.props.searchTerm : ''}
          autoComplete="off"
          ></input>
          <button id="campaignButton" ref={this.searchButton} onClick={this.getInfo}> Get Info</button>
        </div>


        <div className={`coldSmtpSearch-Error ${this.state.showError ? 'show' : 'hidden'}`} >{this.state.errorMessage}</div>

      </div>


    );
  }
}


const mapStateToProps = (state) => {
  return { coldSmtp: state.coldSmtp };
};



export default connect(mapStateToProps, { coldSMTPSearch })(ColdSmtpSearch);

